import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import ModalWrapper from '../../../components/Modals/ModalWrapper';
import FontSizes from '../../../constants/FontSizes';
import { MainColors } from '../../../constants/Colors';
import { MaterialCommunityIcons } from '@expo/vector-icons';

const BallotItemDetailsModal = (props) => {
    return (
        <ModalWrapper visible={props.visible} onModalBackgroundPressed={props.onModalBackgroundPressed}>
            {props.infoData ? (
                <View style={styles.container}>
                    <View style={styles.headerContainer}>
                        <Text style={styles.title}>{props.title}</Text>
                        <TouchableOpacity onPress={props.onCloseButtonPressed} accessibilityLabel='Close'>
                            <MaterialCommunityIcons name="close" size={16} color={MainColors.mediumGray} />
                        </TouchableOpacity>
                    </View>
                    <Text style={styles.label}>Description</Text>
                    <Text style={styles.text}>
                        {props.description ? props.description : 'No description to show'}
                    </Text>
                    <Text style={styles.label}>Choices</Text>
                    {props.choices && props.choices.map(c => (
                        <View key={c.choiceId}>
                            <Text style={styles.choiceTitle}>{c.choiceTitle}</Text>
                            <Text style={styles.text}>{c.choiceExplanation}</Text>
                        </View>
                    ))}
                </View>
            ) : (null)}
        </ModalWrapper>
    )
}

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 20,
        width: '100%',
    },
    headerContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottomWidth: 1,
        borderBottomColor: MainColors.faintGray,
        paddingBottom: 10
    },
    title: {
        fontSize: FontSizes.medium,
        fontWeight: '600',
        color: MainColors.darkGray,
        textAlign: 'center',
    },
    label: {
        fontSize: FontSizes.medium,
        fontWeight: '600',
        color: MainColors.mediumGray,
        marginTop: 10,
        marginBottom: 5
    },
    text: {
        color: MainColors.darkGray,
        fontSize: FontSizes.medium,
        marginBottom: 10
    },
    choiceTitle: {
        color: MainColors.darkGray,
        fontSize: FontSizes.medium,
        fontWeight: '600',
    },
});

export default BallotItemDetailsModal;